import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {networkDeviceActions} from "../../../actions/network-device.actions";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Link} from "react-router-dom";
import NetworkDeviceForm from "./_forms/NetworkDeviceForm";
import {Spinner} from "react-bootstrap";

class NetworkDeviceEditPage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        const id = this.props.match.params.id;
        dispatch(networkDeviceActions.getNetworkDeviceById(id))
    }

    render() {
        const { t , singleDevice } = this.props;

        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: 'edit_network_device', path: '#' },
            { value: singleDevice?.label, path: '#' }
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{t('edit_network_device')}</h4>
                <h5 className='font-italic'>{ singleDevice?.label }</h5>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <Link to="/panel/network-device" className="btn btn-secondary float-right btn-create">
                                <i className="fas fa-undo"> </i> &nbsp; { t('back-to-list') }
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        { singleDevice ? (
                            <NetworkDeviceForm data={singleDevice} />
                        ) : (<Spinner animation={"border"} />) }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { singleDevice } = state.networkDeviceReducer;
    return {
        singleDevice
    };
};

export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceEditPage));
